import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  margin: 20px 0;
`;
